const RETURN_URL_KEY = 'url'

export const buildLogoutURL = ({ logoutLocation, returnURL }) => {
  const queryParams = {
    [RETURN_URL_KEY]: returnURL
  }

  const searchParams = new URLSearchParams(queryParams)
  const querystring = searchParams.toString()

  return `${logoutLocation}?${querystring}/`
}
